import React, { Component } from "react";

import { connect } from "react-redux";
import { Button } from "reactstrap";

//Import i18n
import { withTranslation } from "react-i18next";

//Import Megamenu

// Redux Store
import { changeSidebarType, toggleRightSidebar } from "../../store/actions";
import { Grid } from "@mui/material";

//Import logo Images

//Import Social Profile Images

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSearch: false,
            isSocialPf: false,
        };
        this.toggleMenu = this.toggleMenu.bind(this);
    }
    /**
     * Toggle sidebar
     */
    toggleMenu() {
       if (this.props.leftSideBarType === "default") {
             this.props.changeSidebarType("condensed", false);
           } else if (this.props.leftSideBarType === "condensed") {
             this.props.changeSidebarType("default", false);
           }
    }

    render() {
        return (
            <React.Fragment>
                <header id="page-topbar-header" style={{ padding: "6px 6px", borderBottom: "1px solid #E9E9E9" }}>
                    {/* {
                        this.props.currentWidth <= 768 &&
                        <Button
                            size="sm"
                            color="none"
                            type="button"
                            onClick={this.toggleMenu}
                            className="px-3 font-size-24 header-item waves-effect"
                            id="vertical-menu-btn"
                        >
                            <i className="ri-menu-2-line align-middle"></i>
                        </Button>
                    } */}
                    {/* <div className="d-flex align-items-center w-100">
                        {this.props.breadcrumb}
                        {this.props.children}
                    </div> */}
                    <div className="page-topbar-header-word" style={{ display: "flex", justifyContent: "space-between" }}>
                        <>
                            {
                                this.props.globalheader ?
                                    <Grid item direction={"row"} xs={4} display={"flex"} alignItems={"center"}>
                                        <Button
                                            size="sm"
                                            color="none"
                                            type="button"
                                            onClick={this.toggleMenu}
                                            className="px-3 font-size-24 header-item waves-effect"
                                            id="vertical-menu-btn"
                                        >
                                            <i className="ri-menu-2-line align-middle"></i>
                                        </Button>
                                    </Grid>

                                    :
                                    <Grid item display={'flex'}>
                                        {
                                            this.props.currentWidth <= 768 &&
                                            <Button
                                                size="sm"
                                                color="none"
                                                type="button"
                                                onClick={this.toggleMenu}
                                                className="px-3 font-size-24 header-item waves-effect"
                                                id="vertical-menu-btn"
                                            >
                                                <i className="ri-menu-2-line align-middle"></i>
                                            </Button>
                                        }
                                        {this.props.breadcrumb}
                                    </Grid>
                            }
                        </>
                        {
                            <Grid
                                item
                                paddingRight={2}
                                display={"flex"}
                                alignItems={"center"}
                            >
                                {this.props.children}
                            </Grid>
                        }
                    </div>
                </header>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { layoutType, currentWidth, leftSideBarType } = state.Layout;
    return { layoutType, currentWidth, leftSideBarType };
};

export default connect(mapStatetoProps, { toggleRightSidebar, changeSidebarType, })(withTranslation()(Header));
